import { SelectField, SubmitDialog } from '@roc/ui';
import { useDrawsStore } from '@roc/feature-draws';
import { observer } from 'mobx-react';

export const LinkTransactionToDraw = observer(({ loanId, drawId, afterActionExecuted }) => {

  const { drawStore: { drawActionsStore } } = useDrawsStore();

  const confirmHandler = () => {
    drawActionsStore.linkTransactionId(drawId, afterActionExecuted);
  }

  return (
    <SubmitDialog
      title="Link Transaction to Draw"
      open={drawActionsStore.isLinkTransactionToDrawDialogOpen}
      body={
        <>
          <SelectField
            options={drawActionsStore.transactionList}
            testId={'transactionDropdown'}
            value={drawActionsStore.linkTransactionOption}
            onChange={value => drawActionsStore.setLinkTransactionOption(value)}
            fullWidth
            variant="outlined"
          />
        </>
      }
      handleClose={() => drawActionsStore.setIsLinkTransactionToDrawDialogOpen(false)}
      handleOk={confirmHandler}
      cancelButtonText='Cancel'
    />
  );
});
